export default {
	create (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop/create', params)
	},
	update (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop/update', params)
	},
	all (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop/all', params)
	},
	one (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop/one', params)
	},
	search (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop/search', params)
	},
	all_am_area (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop/all_am_area', params)
	},
	all_department (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop/all_department', params)
	},
	all_division (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop/all_division', params)
	},
	all_section (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'shop/all_section', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/Shop.js